<template>
  <div class="search_bar">

    <div class="search-bar-item mt-30">
      <div class="label">订单编号</div>
      <el-input class="bg-slateGray number_input" v-model="formData.order_id" clearable/>
      <div class="label">手机号</div>
      <el-input class="bg-slateGray number_input" v-model="formData.mobile" clearable/>
    </div>

    <div class="search-bar-item mt-20">
      <div class="label">收货人</div>
      <el-input class="bg-slateGray number_input" v-model="formData.receiver_name" clearable/>

      <!-- <div class="label">下单时间</div>
      <el-date-picker
        class="time-picker"
        v-model="formData.time"
        type="datetimerange"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker> -->
      <button class="ml-20 btn-secondary-orange" @click="handelSearch()">
        <span>搜索</span>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        formData: {
          order_id: null,
          mobile: null,
          receiver_name: null,
          time: null,
        }
      }
    },
    methods: {
      initData() {
        this.formData ={
          order_id: null,
          mobile: null,
          receiver_name: null,
          time: null,
        };
      },
      handelSearch() {
        this.$emit('on-search', this.formData);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search_bar{
    .search-bar-item {
      @include flexbox(row, flex-start, center);
    }
    .label {
      width: 78px;
      text-align: right;
      color: $sliver;
      font-size: 12px;
      margin-right: 8px;
    }
    .el-select{
      width: 118px;
    }
    .number_input{
      width: 158px;
      height: 32px;
      font-size: 12px;
    }
    .start_picker,
    .end_picker{
      width: 110px;
    }
  }
</style>